import React from 'react';

interface IconFollowingProps {
  className?: string;
  size?: number;
  color?: string;
}

export const IconFollowing: React.FC<IconFollowingProps> = ({ className = '', size = 16, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_8810_4277)">
        <path
          d="M0.69873 13.2312C1.4294 10.8379 3.69206 9.04319 6.29006 9.04319C7.92673 9.04319 9.43006 9.75519 10.5014 10.8799M6.28806 7.04653C7.12226 7.04653 7.92229 6.71514 8.51215 6.12528C9.10201 5.53541 9.4334 4.73539 9.4334 3.90119C9.4334 3.067 9.10201 2.26697 8.51215 1.67711C7.92229 1.08724 7.12226 0.755859 6.28806 0.755859C5.45387 0.755859 4.65384 1.08724 4.06398 1.67711C3.47411 2.26697 3.14273 3.067 3.14273 3.90119C3.14273 4.73539 3.47411 5.53541 4.06398 6.12528C4.65384 6.71514 5.45387 7.04653 6.28806 7.04653Z"
          stroke={color}
          strokeWidth="1.25"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.61523 12.9547H15.3019M13.0126 10.6641L15.3019 12.9534L13.0126 15.2427"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8810_4277">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconFollowing;
